import routes from './influencerReferralCode.routes';

export const influencerReferralCodeModule = {
    routes
};